import React, { useState } from 'react'
import AITool from '../components/AITool'
import './UtilityTools.css'

const UtilityTools: React.FC = () => {
  const [activeTool, setActiveTool] = useState('resume')

  const tools = [
    {
      id: 'resume',
      name: 'Resume Feedback',
      description: 'Get professional feedback and suggestions for your resume',
      icon: '📄',
      endpoint: '/.netlify/functions/resume-feedback',
      fields: [
        { name: 'resume', label: 'Resume Content', type: 'textarea' as const, placeholder: 'Paste your resume content here' },
        { name: 'position', label: 'Target Position', type: 'text' as const, placeholder: 'e.g., Software Engineer, Marketing Manager' },
        { name: 'experience', label: 'Experience Level', type: 'select' as const, options: ['Entry Level', 'Mid Level', 'Senior Level', 'Executive'] },
        { name: 'focus', label: 'Focus Areas', type: 'select' as const, options: ['Content & Structure', 'Skills & Keywords', 'Achievements', 'All Areas'] }
      ]
    },
    {
      id: 'summarizer',
      name: 'Text Summarizer',
      description: 'Summarize long articles, documents, or text content',
      icon: '📝',
      endpoint: '/.netlify/functions/summarize',
      fields: [
        { name: 'text', label: 'Text to Summarize', type: 'textarea' as const, placeholder: 'Paste the text you want to summarize' },
        { name: 'length', label: 'Summary Length', type: 'select' as const, options: ['Short (2-3 sentences)', 'Medium (4-6 sentences)', 'Long (7-10 sentences)'] },
        { name: 'style', label: 'Summary Style', type: 'select' as const, options: ['Bullet Points', 'Paragraph', 'Key Points Only'] },
        { name: 'focus', label: 'Focus (Optional)', type: 'text' as const, placeholder: 'e.g., main arguments, key findings, conclusions' }
      ]
    },
    {
      id: 'rephraser',
      name: 'Text Rephraser',
      description: 'Rephrase text while maintaining the original meaning',
      icon: '🔄',
      endpoint: '/.netlify/functions/rephrase',
      fields: [
        { name: 'text', label: 'Text to Rephrase', type: 'textarea' as const, placeholder: 'Enter the text you want to rephrase' },
        { name: 'tone', label: 'New Tone', type: 'select' as const, options: ['Professional', 'Casual', 'Academic', 'Creative', 'Simple', 'Formal'] },
        { name: 'style', label: 'Rephrasing Style', type: 'select' as const, options: ['Paraphrase', 'Simplify', 'Expand', 'Academic', 'Creative'] },
        { name: 'preserve', label: 'Preserve Keywords', type: 'select' as const, options: ['Yes', 'No'] }
      ]
    },
    {
      id: 'template',
      name: 'Template Filler',
      description: 'Auto-fill templates like cover letters, emails, and forms',
      icon: '📋',
      endpoint: '/.netlify/functions/template-filler',
      fields: [
        { name: 'template', label: 'Template Type', type: 'select' as const, options: ['Cover Letter', 'Email Template', 'Job Application', 'Business Proposal', 'Thank You Letter', 'Custom'] },
        { name: 'context', label: 'Context Information', type: 'textarea' as const, placeholder: 'Provide relevant details: company name, position, your background, etc.' },
        { name: 'tone', label: 'Tone', type: 'select' as const, options: ['Professional', 'Friendly', 'Formal', 'Enthusiastic', 'Confident'] },
        { name: 'customTemplate', label: 'Custom Template (Optional)', type: 'textarea' as const, placeholder: 'If using custom template, paste it here with placeholders like [COMPANY]' }
      ]
    }
  ]

  return (
    <div className="utility-tools">
      <div className="page-header">
        <h1>Utility Tools</h1>
        <p>Get resume feedback, summarize text, rephrase content, and fill templates</p>
      </div>

      <div className="tools-tabs">
        {tools.map((tool) => (
          <button
            key={tool.id}
            className={`tab-button ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
          >
            <span className="tool-icon">{tool.icon}</span>
            <span className="tool-name">{tool.name}</span>
          </button>
        ))}
      </div>

      <div className="tool-content">
        {tools.map((tool) => (
          <div key={tool.id} className={`tool-panel ${activeTool === tool.id ? 'active' : ''}`}>
            <AITool
              title={tool.name}
              description={tool.description}
              endpoint={tool.endpoint}
              fields={tool.fields}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default UtilityTools 